jQuery(document).ready(function($) { 


	var header = $('#masthead');
	var h_window = $(window).height();
	var l_window = $(window).width();


    $('.to_nicedropdown-js').niceSelect();
    $('.nice-select ul.list li:first-child,.nice-select .current').text("Votre demande concerne*");
    $('.nice-select ul.list li:first-child').css('display', 'none');

	 /*  ***************************
    SCROLL FIXED MENU 
  ******************************** */
   $(window).scroll(function () {
     // if(l_window > 1023){
        action_on_scroll();
     // }
    });

    function action_on_scroll(){
      l_window = parseInt($(window).width());
       if ($(window).scrollTop() > 50){
          header.addClass("Masthead--sticky");
          $("body").addClass('header--sticky');
        }else{
           header.removeClass("Masthead--sticky");
           $("body").removeClass('header--sticky');
        }
   }



   /**************************************************************************************/
      /*********************** GALERIE IMAGE DERRIERE BG HEADER  *********************************/
   /**************************************************************************************/


   var swiper_headerGallery = new Swiper('.swiper-headerGallery', {

     // If we need pagination
       spaceBetween: 0, // try '5%' if you want
       slidesPerView: 1,
       loop: true,
       centeredSlides:false,
        autoplay: {
           delay: 3500,
           disableOnInteraction: true,
       },

      pagination: {
         el: '.swiper-pagination-headerGallery',
         clickable: true
       }
   });   




/**********************************************************************/
   /*************** Galerie d'image // Flexible  ****************/
/**********************************************************************/

   

   $( ".mGalerie .gallerie-thumb" ).each(function( index ) {
      var id_galerie_masonry = $(this).attr('id');
 
        var $container = $('#'+id_galerie_masonry);
       $container.imagesLoaded(function () {
           $container.masonry({
               itemSelector: '.item-img',
               columnWidth: '.item-img-sizer',
               percentPosition: true
           });
       }); 

        if ($container) {
              lightGallery(document.getElementById(id_galerie_masonry), {
                 plugins: [lgThumbnail],
                 selector: '.item-img',
                 thumbnail: true
             });
        }

   });



   /********************************************************/
   /************* LOCALTION // LISTE DE LIEU + OPEN LIGHTBOX AU CLICK AVEC SAME HTML + SWIPER **********************/
   /********************************************************/



   var swiper_lb ='';

   /********************************************************/
   /************* ALL SECTION GALLERY **********************/
   /********************************************************/
   var swiper_gallery_St='';
   $( ".SingleLocation" ).each(function( index ) {
      var id_location = $(this).attr('id');
      if ($(this).find('.swiper-standardG').length) {

         var swiper_gallery_St = new Swiper("#gallery-"+id_location, {

         // If we need pagination
             spaceBetween: 0, // try '5%' if you want
             slidesPerView: 1,
             loop: true,
             centeredSlides:false,
               navigation: {
                nextEl: '.next-'+id_location,
                prevEl: '.prev-'+id_location
              },
              autoplay: {
                 delay: 3500,
                 disableOnInteraction: true,
             },

            pagination: {
               el: '.swiper-pagination-'+id_location,
               clickable: true
             }
         });   


      }

   });


   function cancelClassActive(){
        
         $( "a.js-action-schema" ).removeClass('active_lb');
         $( "g.g_x5F_hover" ).removeClass('active_lb');
  }

   function startSwiper(){

         swiper_lb = new Swiper(".featherlight-content .swiper-standardG", {

         // If we need pagination
             spaceBetween: 0, // try '5%' if you want
             slidesPerView: 1,
             loop: true,
             centeredSlides:false,
               navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
              },
              pagination: {
               el: '.swiper-pagination',
               clickable: true
             },
              autoplay: {
                 delay: 3500,
                 disableOnInteraction: true,
             },
      
         });   

        
      }

      
   function destroySwiper(){
       swiper_lb.destroy();
   }



  /**** Schema zone cliquable ***/
  /***************************************/
    $( ".g_x5F_hover" ).click(function() {
      
        var destination_modal = $("#l-"+$(this).data('info'));

        $( this ).addClass('active_lb');
        $('a.js-action-schema[data-cores="'+$(this).data('info')+'"]').addClass('active_lb');


        if (destination_modal.length ) { 

          $.featherlight(destination_modal, {
            closeIcon: '<i class="icon-close">',
             beforeClose: cancelClassActive,
             afterOpen: startSwiper,
             afterClose: destroySwiper
          });
        }
    //if()
    //
  });

      

    $( ".HotSpot-Button" ).hover(
      function() {
        corres_schema = $( this ).data('cores');
        console.log(corres_schema);
        $('.g_x5F_hover.'+corres_schema).addClass('active');
      }, function() {
        $('.g_x5F_hover.'+corres_schema).removeClass('active');
      }
    );

    $( ".g_x5F_hover" ).hover(
      function() {
        corres_schema = $( this ).data('info');
    
        $('.HotSpot-Button.'+corres_schema).addClass('hover-hotspot');
      }, function() {
        $('.HotSpot-Button.'+corres_schema).removeClass('hover-hotspot');
      }
    );


    // Hover liste lieu sur la gauche
    var corres_schema = '';

    $( "a.js-action-schema" ).hover(
      function() {
        corres_schema = $( this ).data('cores');
        $('.schema-lieu-foreziales').find('g.'+corres_schema).addClass('active');
        $('.HotSpot-Button.'+corres_schema).addClass('hover-hotspot');
      }, function() {
        $('.schema-lieu-foreziales').find('g.'+corres_schema).removeClass('active');
        $('.HotSpot-Button.'+corres_schema).removeClass('hover-hotspot');
      }
    );


    // Click sur lieu sur la gauche
    $( "a.js-action-schema" ).click(function(e) {  
        var destination_modal = $("#l-"+$(this).data('cores'));
        corres_schema = $( this ).data('cores');

        console.log(corres_schema);

        $( this ).addClass('active_lb');
        $('.schema-lieu-foreziales').find('g.'+corres_schema).addClass('active_lb');
       
        if (destination_modal.length ) { 
          $.featherlight(destination_modal, {
             closeIcon: '<i class="icon-close">',
             beforeClose: cancelClassActive,
             afterOpen: startSwiper,
             afterClose: destroySwiper
          });
        }

        e.preventDefault();

  });



   
/************************************************************************************/
  /************************************************************************************/
  /************************************************************************************/
/********************** SCROLL MENU-RAPIDE ******************************/
/************************************************************************************/
  /************************************************************************************/
/************************************************************************************/


var topMenuHeight = 120;
  l_window = parseInt($(window).width());
 if(l_window < 1025){
    topMenuHeight = 40;
 }

if ( $( ".QuickMenuScroll-Container" ).length) {
     // Cache selectors
  var lastId,
      topMenu = $(".QuickMenuScroll"),
      // All list items
      menuItems = topMenu.find("a"),
      // Anchors corresponding to menu items
      scrollItems = menuItems.map(function(){
        var only_anchor = $(this).attr("href").split('#');
      // console.log(only_anchor[1]);
        var item = $("#"+only_anchor[1]); //var item = $($(this).attr("href").split('#'));
        if (item.length) { return item; }
      });

  // Bind click handler to menu items
  // so we can get a fancy scroll animation
  menuItems.click(function(e){
    var item_split = $(this).attr("href").split('#');
    var href = "#"+item_split[1];
    var variable = 0;
        if (href == "#localisation")  variable = 40;
        var offsetTop = href[1] === "#" ? 0 : $(href).offset().top-topMenuHeight+1-variable;
      

         $('html, body').stop().animate({ 
            scrollTop: offsetTop
        }, 500, function() {
          
        // Animation complete.
      });
       
     
      e.preventDefault();
  });



  // Bind to scroll
  $(window).scroll(function(){
     // Get container scroll position
     var fromTop = $(this).scrollTop()+topMenuHeight;
     
     // Get id of current scroll item
     var cur = scrollItems.map(function(){
      if($(this).attr('id') == "realisations") variable_top = 170;else variable_top = 0;
       if ($(this).offset().top - variable_top < fromTop)
         return this;
     });
     // Get the id of the current element
     cur = cur[cur.length-1];
     var id = cur && cur.length ? cur[0].id : "";
     
   //  console.log("A"+object_var.site_url+"/#"+id);

     if (lastId !== id) {
         lastId = id;
         // Set/remove active class

         menuItems
           .parent().removeClass("active_menu")
           .end().filter("[href='#"+id+"']").parent().addClass("active_menu");
     }                   
  });
}

   



  /**********************************************************************/
/*************** SLIDER ALL SAME ANIM // FEATURES / HOME ETC ****************/
/**********************************************************************/

   var features_confiance1 = new Swiper('.js-swiper-features-txt', {
        slidesPerView: 2,
        speed: 8000,
        spaceBetween:0,
        allowTouchMove: false,
        loop:true,
        autoplay: {delay: 0,pauseOnMouseEnter: false, disableOnInteraction: false},
         breakpoints: {
           640: {
             slidesPerView: 3,
           },    
           768: {
             slidesPerView: 4,
           },
           1250: {
             slidesPerView: 4,
           },
           1450: {
             slidesPerView: 5.5,
           }
         }

   });

   var features_confiance2 = new Swiper('.js-swiper-features-txt2', {
        slidesPerView: 2,
        speed: 8000,
        spaceBetween:0,

        allowTouchMove: false,
        loop:true,
        autoplay: {reverseDirection:true,delay: 0,pauseOnMouseEnter: false, disableOnInteraction: false},
         breakpoints: {
           640: {
             slidesPerView: 3,
           },    
           768: {
             slidesPerView: 4,
           },
           1250: {
             slidesPerView: 4,
           },
           1450: {
             slidesPerView: 5.5,
           }
         }
   });




   /**************************************************************************************/
   /*********************** MODULE A / Services *********************************/
   /**************************************************************************************/

   var menu_pagination_mA = [];
   var titleMASlide = document.querySelectorAll('.swiper-container-SliderSituer .slide-img-situation-title');
      titleMASlide.forEach(function (sandwich, index) {
      menu_pagination_mA.push(sandwich.innerHTML);
   });

   var swiper_module_a = new Swiper('.swiper-container-SliderSituer', {
   // pagination: {
   //   el: '.swiper-bullet-pagination',
   //   clickable: true
   // },

   // If we need pagination
    spaceBetween: 16, // try '5%' if you want
    centeredSlides: true,
    slidesPerView: 1,
    loop: false,

       navigation: {
             nextEl: '.swiper-button-next',
             prevEl: '.swiper-button-prev'
         },

      pagination: {
        el: '.sliderSituer-rowTxt',
        clickable: true,
          renderBullet: function (index, className) {
            return '<span class="button-label ' + className + '"><i class="icon-right" aria-hidden="true"></i> ' + (menu_pagination_mA[index]) + '</span>';
          },
    }

   // autoplay: {
   //   delay: 6000,
   //   disableOnInteraction: false
   // },
   // loop: true,
   // watchSlidesProgress: true
   });

  // FORM CONTACT LABEL ///

  $( ".wpcf7-form label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

  $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });

   var  Sitenavigation = $("#site-navigation");
   var  Menutoggle = $(".menu-toggle");

    $( "#primary-menu > li > .sub-menu a" ).click(function(e) {

      var $current_url = document.URL.split("#");
      var url_withour_anchor= $current_url[0].substring(4); // remove http: (OU HTTPS attention ! ) // PODOM EN LIGNE : https (!!5)

      if ($(e.currentTarget).attr('href').indexOf("#") != -1 && $(e.currentTarget).attr('href').indexOf(url_withour_anchor) > -1) {
            var anchor_url = $(e.currentTarget).attr('href').split("#");
            var $hash_location = $("#"+anchor_url[1]);
            var offsetTop = $hash_location === "#" ? 0 : $($hash_location).offset().top-topMenuHeight;
            
              if(Sitenavigation.hasClass('toggled')){
                    Menutoggle.trigger( "click" );
                }

              $('html, body').stop().animate({ 
                  scrollTop: offsetTop
              }, 500);

              e.preventDefault();
        }
    });
     


  // ** //
  // AU RECHARGEMENT OU AU SCROLL DE LA PAGE = ON FAIT SCROLL SMOOTH VERS LA POSITION // 
  // ** // 
  var variablerefresh = 0;
  function scroll_good_anchor(){
     if(window.location.hash) {
      var $hash_location = window.location.hash;
      if($($hash_location).length){

  //        var href = "#"+item_split[1];
  if ($hash_location == "#localisation" || $hash_location == "#prog-spectacles")  variablerefresh = 40;

        console.log($hash_location);
         var offsetTop = $hash_location === "#" ? 0 : $($hash_location).offset().top-topMenuHeight-variablerefresh;
          $('html, body').stop().animate({ 
              scrollTop: offsetTop
          }, 500);
      }
    } 
  }

  scroll_good_anchor();



}); // fin ready menu